import { CLAIM_VALIDATION_CONSTANTS, PRODUCT_INFORMATION_CONSTANTS, CLAIM_INFORMATION_CONSTANTS, ADDITIONAL_INFORMATION_CONSTANTS, FILE_ATTACHMENTS_CONSTANTS } from "../../forms/IPL/constants";
import { REVIEW_PAGE_CONSTANTS } from "../../forms/constants";
import * as ClaimValidation from "../../forms/IPL/Step1/ClaimValidation";
import * as ProductInformation from "../../forms/IPL/Step2/ProductInformation";
import * as ClaimInformation from "../../forms/IPL/Step3/ClaimInformation";
import * as AdditionalInformation from "../../forms/IPL/Step4/AdditionalInformation";
import * as FileAttachments from "../../forms/IPL/Step5/FileAttachments";
import { cloneDeep } from "lodash";
import { FormValidationType } from "../../forms/types";

// IPL step names - no longer stage-based
export const IPL_STEP_NAMES = [
  CLAIM_VALIDATION_CONSTANTS.FORM_NAME,
  PRODUCT_INFORMATION_CONSTANTS.FORM_NAME,
  CLAIM_INFORMATION_CONSTANTS.FORM_NAME,
  ADDITIONAL_INFORMATION_CONSTANTS.FORM_NAME,
  FILE_ATTACHMENTS_CONSTANTS.FORM_NAME,
  REVIEW_PAGE_CONSTANTS.FORM_NAME,
];

// IPL form validations - no longer stage-based
export const FORM_VALIDATIONS: Record<string, FormValidationType> = {
  [CLAIM_VALIDATION_CONSTANTS.FORM_NAME]: cloneDeep(
    ClaimValidation.formValidation
  ),
  [PRODUCT_INFORMATION_CONSTANTS.FORM_NAME]: cloneDeep(
    ProductInformation.formValidation
  ),
  [CLAIM_INFORMATION_CONSTANTS.FORM_NAME]: cloneDeep(
    ClaimInformation.formValidation
  ),
  [ADDITIONAL_INFORMATION_CONSTANTS.FORM_NAME]: cloneDeep(
    AdditionalInformation.formValidation
  ),
  [FILE_ATTACHMENTS_CONSTANTS.FORM_NAME]: cloneDeep(FileAttachments.formValidation),
};